export default class Logos {
  constructor() {
    this.logosSelector = '.logos .logo';
    this.buttonsSelector = `${this.logosSelector} button`;
    this.openClass = 'open';
  }

  init() {
    this.logos = document.querySelectorAll(this.logosSelector);
    this.logos.forEach((logo) => {
      logo.addEventListener('mouseenter', () => {
        logo.classList.add(this.openClass);
      });

      logo.addEventListener('mouseleave', () => {
        logo.classList.remove(this.openClass);
      });
    });

    this.buttons = document.querySelectorAll(this.buttonsSelector);
    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.close();
      });
    });
  }

  close(element = false) {
    const logos = element === false ? this.logos : [element];
    logos.forEach((i) => {
      i.classList.remove(this.openClass);
    });
  }
}
